import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    FullParamMapResolver,
    ModalContainer
} from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { LotamDetailsDialogueComponent } from '../lotam-details-dialogue/lotam-details-dialogue.component';
import { LotamListComponent } from '../lotam-list/lotam-list.component';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
            },
            {
                path: 'list',
                component: ModalContainer,
                data: {
                    modalContent: LotamListComponent,
                    modalClass: 'modal-lg',
                    relativeRoute: '../../'
                },
                resolve: {
                    initialState: FullParamMapResolver
                }
            },
            {
                path: ':lotamId',
                component: ModalContainer,
                data: {
                    modalContent: LotamDetailsDialogueComponent,
                    modalClass: 'modal-lg',
                    relativeRoute: '../../'
                },
                resolve: {
                    initialState: FullParamMapResolver
                }
            }
        ])
    ],
    exports: [RouterModule]
})
export class LotamRoutingModule {}
